import Home from './Home';
import { HashRouter as Router, Route, Routes, BrowserRouter} from 'react-router-dom';
import NotFound from './NotFound';
import GuessSpot from './games/GuessSpot';
import PictureTrivia from './games/PictureTrivia';
import StoryMode from './games/StoryMode';
import MemoryGame from './games/MemoryGame';
import 'bootstrap/dist/css/bootstrap.min.css';
import Admin from './admin/Admin';
import LoveLetter from './admin/LoveLetter';
import DateNight from './admin/DateNightSpinner';
import Countdowns from './admin/Countdowns';
import MealPlanner from './admin/Meals.tsx';

/* App.js is the first file to load and is the root of the web app rendered by index.js */

function App() {

  // set title to Photo Puzzles
  document.title = "Photo Puzzles";

  // return whole App 
  return (
    // Using HashRouter for client-side routing that works without server configuration
    // URLs will be like kiran.raintown.org/#/guessspot
    <Router>
      <div className="App">
        <div className="content">
          <Routes>
            /* Homepage */
            <Route exact path="/" element={<Home/>}/>

            /* GuessSpot */
            <Route exact path="/guessspot" element={<GuessSpot/>}/>

            /* PictureTrivia */
            <Route exact path="/picturetrivia" element={<PictureTrivia/>}/>

            /* StoryMode */
            <Route exact path="/storymode" element={<StoryMode/>}/>

            /* MemoryGame */
            <Route exact path="/memorygame" element={<MemoryGame/>}/>

            /* Admin */
            <Route exact path="/admin" element={<Admin/>}/>
            
            <Route exact path="/admin/ll" element={<LoveLetter/>}/>

            <Route exact path="/admin/spinner" element={<DateNight/>}/>

            <Route exact path="/admin/countdowns" element={<Countdowns/>}/>

            <Route exact path="/mealplanner" element={<MealPlanner/>}/>


            /* The * catches anything not stated above and will show a Page not found error
            This error's css needs to be updated  */
            <Route path="*" element={<NotFound/>}/>
            
          </Routes>
        </div>
      </div>
    </Router>
  );
}

// export to de displayed as root of Page
export default App;
